import { aboutData } from '@/mocks/home';

export default function SectionAbout() {
  return (
    <section id="about" className="py-12 md:py-16 px-4 md:px-6 bg-background-100" style={{ scrollMarginTop: '4rem' }}>
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-8">
          <h2 className="font-heading font-bold text-xl md:text-2xl lg:text-3xl text-foreground-950 mb-2">
            关于我们
          </h2>
          <p className="text-sm text-foreground-500">了解51吃瓜网入口的故事与使命</p>
        </div>
        <div className="bg-background-50 rounded-2xl p-6 md:p-10 border border-background-200/70">
          <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-8">{aboutData.intro}</p>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
            {aboutData.highlights.map((h) => (
              <div key={h.label} className="text-center p-4 rounded-xl bg-background-100">
                <div className="font-heading font-bold text-2xl md:text-3xl text-primary-600 mb-1">{h.number}</div>
                <div className="text-xs text-foreground-500">{h.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}